<template>
  <el-row :gutter="20">
    <el-col :md="12" :xs="24">
      <TimeSearch
          :full-width-select="true"
          ref="timeSearch"
          :short-date="true"
          :month="true"
          :free-date-time="true"
      />
    </el-col>
    <slot name="admin-extension"></slot>
  </el-row>
  <el-button type="success" style="margin-top: 30px" plain @click="getReport(true)" :disabled="reportButtonDisabled"
             :loading="reportLoading">Применить
  </el-button>
  <div v-show="reportReady" style="margin-top: 50px">
    <StatisticsTable
        :report-loading="reportLoading"
        :from-date="fromDate"
        :to-date="toDate"
        :total-auths="totalAuths"
        :stat-data="statData"
    />
    <AuthorizationsTable
        :page-loading="pageLoading"
        :all-auths="allAuths"
        :total-auths="totalAuths"
        :subusers="subusers"
        :report-params="reportParams"
        :download-url="downloadReportUrl"
        @pagination-changed="handlePaginationEvents"
    />
  </div>
</template>

<script>
import TimeSearch from "@shared/components/reports/time-search.component"
import AuthorizationsTable from "./tables/auths-table.component"
import StatisticsTable from "./tables/statistics-table.component"
import moment from "moment"

export default {
  name: "AuthorizationsReport",
  components: {TimeSearch, AuthorizationsTable, StatisticsTable},
  props: {
    getReportUrl: String,
    downloadReportUrl: String,
    mutateParams: {
      type: Function,
      default: p => p
    },
    reportButtonDisabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handlePaginationEvents(event) {
      if (event.size) {
        this.pageSize = event.size
      }
      if (event.page) {
        this.currentPage = event.page
      }
      this.getReport()
    },
    getReportParams() {
      let dateFilter = this.$refs.timeSearch.getDateTimeFilter()
      return this.mutateParams({
        date_from: dateFilter.from.toDate(),
        date_to: dateFilter.to.toDate(),
        pageNumber: this.currentPage,
        pageSize: this.pageSize,
      })
    },
    async getReport(doCount = false) {
      this.pageLoading = true
      if (doCount) {
        this.reportLoading = true
      }
      this.reportParams = this.getReportParams()
      this.reportParams.doCount = doCount
      this.fromDate = moment(this.reportParams.date_from).format("DD.MM.YYYY HH:mm")
      this.toDate = moment(this.reportParams.date_to).format("DD.MM.YYYY HH:mm")
      let resp = await this.axios.get(this.getReportUrl, {params: this.reportParams})
      this.allAuths = resp.data.auths
      this.pageLoading = false
      if (doCount) {
        this.statData = resp.data.stat
        this.totalAuths = resp.data.count
        this.subusers = resp.data.subusers
        this.reportReady = true
        this.reportLoading = false
      }
    }
  },
  data() {
    return {
      fromDate: "",
      toDate: "",
      reportReady: false,
      reportParams: {},
      reportLoading: false,
      pageLoading: false,
      downloadUrl: "",
      statData: [],
      allAuths: [],
      subusers: [],
      totalAuths: 0,
      currentPage: 1,
      pageSize: 10
    }
  }
}
</script>